"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var CustomPropTypes = _interopRequireWildcard(require("../../../constants/PropTypes"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UITag = _interopRequireDefault(require("UIComponents/tag/UITag"));

var _i18n = require("ecosystem-marketplace-core/utils/i18n");

var FilterKey = _interopRequireWildcard(require("../../../constants/search/FilterKey"));

var _i18n2 = require("../../../utils/i18n");

var FilterTag = function FilterTag(_ref) {
  var activeCategory = _ref.activeCategory,
      filterKey = _ref.filterKey,
      onCloseClick = _ref.onCloseClick,
      value = _ref.value;
  var renderedTagText = (0, _react.useMemo)(function () {
    switch (filterKey) {
      case FilterKey.CATEGORY_FEATURES:
        return _react.default.createElement(_FormattedMessage.default, {
          message: "appMarketplace.storefront.filters.categoryFeatures.tagText",
          options: {
            value: (0, _unescapedText.default)((0, _i18n.getCategoryFeatureI18nKey)(activeCategory, value))
          }
        });

      case FilterKey.MIN_OVERALL_RATING:
        return _react.default.createElement(_FormattedMessage.default, {
          message: "appMarketplace.storefront.filters.rating.tagText",
          options: {
            rating: value,
            count: parseInt(value, 10)
          }
        });

      case FilterKey.PRICING:
        return _react.default.createElement(_FormattedMessage.default, {
          message: "appMarketplace.storefront.filters.planType.tagText",
          options: {
            value: (0, _unescapedText.default)((0, _i18n2.getPlanTypeFilterI18nKey)(value))
          }
        });

      case FilterKey.PLAN_COMPATIBLE:
      case FilterKey.TIERS:
        return _react.default.createElement(_FormattedMessage.default, {
          message: "appMarketplace.storefront.filters.compatibility.tagText",
          options: {
            value: (0, _unescapedText.default)(filterKey === FilterKey.PLAN_COMPATIBLE ? 'appMarketplace.storefront.filters.compatibility.myPlan' : (0, _i18n.getTierI18nKey)(value))
          }
        });

      case FilterKey.HUBSPOT_FEATURES:
        return _react.default.createElement(_FormattedMessage.default, {
          message: "appMarketplace.storefront.filters.hubspotFeatures.tagText",
          options: {
            value: (0, _unescapedText.default)((0, _i18n.getHubSpotFeatureI18nKey)(value))
          }
        });

      case FilterKey.SYNC:
        return _react.default.createElement(_FormattedMessage.default, {
          message: "appMarketplace.storefront.filters.sync.tagText",
          options: {
            value: (0, _unescapedText.default)((0, _i18n2.getDataSyncFilterI18nKey)(value))
          }
        });

      case FilterKey.CERTIFIED:
        return _react.default.createElement(_FormattedMessage.default, {
          message: "appMarketplace.storefront.filters.certified.tagText"
        });

      case FilterKey.INTEGRATIONS:
        return _react.default.createElement(_FormattedMessage.default, {
          message: "appMarketplace.storefront.filters.integrations.tagText",
          options: {
            value: value
          }
        });

      case FilterKey.SUPPORT_SOURCE:
        return _react.default.createElement(_FormattedMessage.default, {
          message: "appMarketplace.storefront.filters.supportSource.tagText",
          options: {
            value: (0, _unescapedText.default)((0, _i18n2.getSupportSourceFilterI18nKey)(value))
          }
        });

      case FilterKey.SUPPORT_LANGUAGES:
        return _react.default.createElement(_FormattedMessage.default, {
          message: "appMarketplace.storefront.filters.supportedLanguages.tagText",
          options: {
            value: (0, _unescapedText.default)("SharedI18nStrings.languageNames." + value)
          }
        });

      default:
        return null;
    }
  }, [activeCategory, filterKey, value]);
  return _react.default.createElement(_UITag.default, {
    className: "m-left-0 m-right-2 m-y-1",
    closeable: true,
    inline: true,
    onCloseClick: onCloseClick
  }, renderedTagText);
};

FilterTag.propTypes = {
  activeCategory: CustomPropTypes.category,
  filterKey: _propTypes.default.oneOf(Object.values(FilterKey)).isRequired,
  onCloseClick: _propTypes.default.func.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]).isRequired
};
var _default = FilterTag;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/results/FilterTag.js
// module id = 903
// module chunks = 209 210 211 212